import { getCurrentLocale, getRawRequest } from '../../../utils'
import type { BalanceExportFormat, ExportFileResult } from '../types/balanceExport'
import { parseContentDispositionFilename } from './parseContentDispositionFilename'

const EXPORT_FORMAT_MIME: Record<BalanceExportFormat, string> = {
  pdf: 'application/pdf',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

export const fetchBalanceExportFile = async (
  path: string,
  format: BalanceExportFormat,
  fallbackFileName: string,
): Promise<ExportFileResult> => {
  const response = await getRawRequest(path, {
    Accept: EXPORT_FORMAT_MIME[format],
    'accept-language': getCurrentLocale(),
  })
  const fileName = parseContentDispositionFilename(response.headers.get('content-disposition')) ?? fallbackFileName

  return {
    blob: await response.blob(),
    fileName,
  }
}
